(function(){'use strict';
var root=document.querySelector('[data-sb]');if(!root||root.dataset.sbInit)return;root.dataset.sbInit='1';document.body.classList.add('sb-page');
var R=window.SBRender,ids=JSON.parse(root.dataset.variants).map(String),nativeFetch=window.fetch.bind(window),
 status=root.querySelector('[data-sb-status]'),nameInput=root.querySelector('[data-sb-name]'),numInput=root.querySelector('[data-sb-number]'),
 latest=null,latestFlat=null,token=0,vstyle={},lastId=null;
try{vstyle=JSON.parse(root.dataset.vstyle||'{}');}catch(e){}
var BG=R.opt.bgNames;
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function styleNow(){var el=document.querySelector('form.sb-form [name="id"]')||document.querySelector('form[action*="/cart/add"] [name="id"]');return vstyle[el&&el.value]||'Lounge';}

// ---------------------------------------------------------------- form
root.querySelector('[data-sb-bgs]').innerHTML=BG.map(function(n,i){return '<label class="sb-s" title="'+esc(n)+'"><input type="radio" name="properties[Background Color]" value="'+esc(n)+'" data-sb-bg data-i="'+i+'"'+(i?'':' checked')+' aria-label="'+esc(n)+'"><span class="sb-s__box"><canvas data-sb-swatch="'+i+'" width="120" height="120" aria-hidden="true"></canvas></span><b>'+esc(n)+'</b></label>';}).join('');
function bgIndex(){var c=root.querySelector('[data-sb-bg]:checked');return c?+c.dataset.i:0;}
function clean(s){return String(s||'').replace(/\s+/g,' ').trim();}
function values(){return {bg:BG[bgIndex()],name:clean(nameInput.value).slice(0,15),number:numInput.value.replace(/\D/g,'').slice(0,2)};}
function props(){var v=values();return {'Background Color':v.bg,'Custom Name':v.name,'Custom Number':v.number};}
function missing(){var v=values(),m=[];if(!v.name)m.push('name');if(!v.number)m.push('number');return m;}
function warning(){
 var miss=missing();
 [['name','Custom Name is required',nameInput],['number','Custom Number is required',numInput]].forEach(function(f){var g=root.querySelector('[data-sb-g="'+f[0]+'"]'),err=g.querySelector('.sb-error'),bad=miss.indexOf(f[0])>=0;err.hidden=!bad;err.textContent=bad?f[1]:'';f[2].setAttribute('aria-invalid',String(bad));});
 if(miss.length){var el=root.querySelector('[data-sb-g="'+miss[0]+'"]'),inp=el.querySelector('input');if(inp)inp.focus({preventScroll:true});
  var header=document.querySelector('.header-v18__sticky,header'),bottom=header?Math.max(0,Math.min(220,header.getBoundingClientRect().bottom)):120;
  window.scrollTo({top:Math.max(0,el.getBoundingClientRect().top+window.scrollY-bottom-20),behavior:'smooth'});}
 return miss.length===0;
}
function target(f){return !!(f&&ids.indexOf(String((f.querySelector('[name="id"]')||{}).value))>=0);}
function selection(){var v=values();return {bg:bgIndex(),name:v.name||'Isabella',number:v.number||'22'};}

// ---------------------------------------------------------------- theme glue (same behaviour as the other custom pants pages)
function relocate(){
 var f=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(function(x){return target(x)&&(x.closest('.xo-product-info-content')||x.querySelector('.buy-button__add'));});
 if(!f)return;f.classList.add('sb-form');
 var wrap=f.querySelector('#kai-cf');if(!wrap){wrap=document.createElement('div');wrap.id='kai-cf';f.insertBefore(wrap,f.firstChild);}
 if(root.parentNode!==wrap)wrap.appendChild(root);
 var quantity=f.querySelector('.buy-button xo-cart-quantity');
 if(quantity&&!quantity.parentElement.classList.contains('sb-quantity')){quantity.parentElement.classList.add('sb-quantity');var label=document.createElement('span');label.textContent='Quantity';quantity.parentElement.insertBefore(label,quantity);}
 document.querySelectorAll('.pp-step-head').forEach(function(h){var guide=h.querySelector('xo-modal-trigger[xo-name="show-sizeguide"]');if(guide)h.before(guide);h.remove();});
 document.querySelectorAll('[data-cnf]').forEach(function(x){x.hidden=true;x.querySelectorAll('input,select,textarea').forEach(function(i){i.disabled=true;});});
}
function sync(){
 var p=props();
 document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
  if(!target(f)||f.contains(root))return;
  Object.keys(p).forEach(function(k){
   var i=Array.from(f.querySelectorAll('input[data-sb-mirror]')).find(function(x){return x.dataset.sbMirror===k;});
   if(!i){i=document.createElement('input');i.type='hidden';i.name='properties['+k+']';i.dataset.sbMirror=k;f.appendChild(i);}
   i.value=p[k];
  });
 });
}

// ---------------------------------------------------------------- assets + preview
function getJSON(url){return nativeFetch(url,{credentials:'omit'}).then(function(r){if(!r.ok)throw Error(r.status);return r.json();});}
var motifsP=null,soP={};
function motifs(){if(!motifsP){motifsP=getJSON(root.dataset.motifs).then(function(j){return R.loadMotifs(j);});motifsP.catch(function(){motifsP=null;});}return motifsP;}
function pants(style){
 // the shop's own smart-object PSD mockups: Sweatpants = joggers, Lounge = satin pants
 var key=style==='Sweatpants'?'sweat':'satin';
 if(!soP[key]){soP[key]=getJSON(key==='sweat'?root.dataset.soSweat:root.dataset.soSatin).then(function(j){return R.loadSO(key,j);}).then(function(){return key;});soP[key].catch(function(){soP[key]=null;});}
 return soP[key];
}
function firstImages(){
 var list=[];
 document.querySelectorAll('xo-gallery xo-carousel').forEach(function(car){
  var slides=Array.from(car.querySelectorAll('xo-carousel-slide')),main=slides.filter(function(s){return !s.closest('xo-carousel-thumbnail');}),th=slides.filter(function(s){return s.closest('xo-carousel-thumbnail');});
  [main[0],th[0]].forEach(function(s){if(s)s.querySelectorAll('img').forEach(function(im){if(list.indexOf(im)<0)list.push(im);});});
 });
 document.querySelectorAll('img[data-sb-first]').forEach(function(im){if(list.indexOf(im)<0)list.push(im);});
 return list;
}
function setGallery(url){
 firstImages().forEach(function(im){
  if(!im.dataset.sbFirst){im.dataset.sbFirst='1';im.dataset.sbOrig=im.getAttribute('src')||'';im.dataset.sbSrcset=im.getAttribute('srcset')||'';im.dataset.sbSizes=im.getAttribute('sizes')||'';im.dataset.sbAlt=im.alt;}
  im.removeAttribute('srcset');im.removeAttribute('sizes');if(im.getAttribute('src')!==url)im.src=url;im.alt='Your personalized softball pajama pants preview';
 });
}
function restore(){
 latest=null;
 firstImages().forEach(function(im){if(!im.dataset.sbOrig)return;im.src=im.dataset.sbOrig;if(im.dataset.sbSrcset)im.setAttribute('srcset',im.dataset.sbSrcset);if(im.dataset.sbSizes)im.setAttribute('sizes',im.dataset.sbSizes);im.alt=im.dataset.sbAlt;});
}
function showFirstSlide(){
 try{
  var im=firstImages().find(function(x){return x.closest('xo-carousel')&&x.offsetParent!==null&&!x.closest('xo-carousel-thumbnail');});if(!im)return;
  var slide=im.closest('xo-carousel-slide'),car=slide.closest('xo-carousel');
  var th=Array.from(document.querySelectorAll('xo-carousel-thumbnail')).find(function(x){return x.offsetParent!==null;});
  if(th&&window.innerWidth>=750){var first=th.querySelector('xo-carousel-slide');if(first)first.click();}
  var prev=car.querySelector('xo-carousel-prev'),guard=0;
  (function step(){if(slide.hasAttribute('xo-active')||!prev||guard++>12)return;prev.click();setTimeout(step,120);})();
 }catch(e){}
}
// flat 2D design inset bottom-left on the main image (desktop gallery + the separate mobile gallery)
function inset(){
 document.querySelectorAll('.xo-product-info-media-style3__top,.xo-product-info-media-mobile__top').forEach(function(top){
  var b=top.querySelector(':scope > .sb-loupe');
  if(!b){b=document.createElement('div');b.className='sb-loupe';b.innerHTML='<img alt="Your design, flat 2D view">';top.appendChild(b);}
  b.hidden=!latestFlat;if(latestFlat&&b.querySelector('img').getAttribute('src')!==latestFlat)b.querySelector('img').src=latestFlat;
 });
}
var canvas=document.createElement('canvas'),tileCanvas=document.createElement('canvas'),flatCanvas=document.createElement('canvas');
function drawSwatches(){root.querySelectorAll('[data-sb-swatch]').forEach(function(c){R.swatch(+c.dataset.sbSwatch,c,120);});}
function run(){
 var my=++token;status.textContent='Updating your preview…';
 return Promise.all([motifs(),pants(styleNow())]).then(function(a){
  if(my!==token)return;var key=a[1],sel=selection(),start=performance.now();
  R.soPhoto(key,sel,canvas,tileCanvas,true);latest=canvas.toDataURL('image/jpeg',.92);
  R.flat(sel,flatCanvas,700);latestFlat=flatCanvas.toDataURL('image/jpeg',.9);root.dataset.renderMs=String(Math.round(performance.now()-start));
  setGallery(latest);showFirstSlide();inset();status.textContent='';
 }).catch(function(){if(my!==token)return;restore();status.textContent='Preview could not load. Please refresh the page.';});
}

// ---------------------------------------------------------------- input handling
var timer;
function changed(e){
 var i=e.target;
 if(i===numInput)i.value=i.value.replace(/\D/g,'').slice(0,2);
 if(i===nameInput)i.value=i.value.slice(0,15);
 if(i===nameInput||i===numInput){var cnt=i.parentNode.querySelector('[data-sb-count]');cnt.textContent=i.value.length+'/'+cnt.dataset.sbCount;
  if(i.value.trim().length){var err=i.closest('.sb-g').querySelector('.sb-error');err.hidden=true;i.setAttribute('aria-invalid','false');}}
 else if(!i.matches('[data-sb-bg]'))return;
 sync();clearTimeout(timer);timer=setTimeout(run,120);
}
root.addEventListener('input',changed);root.addEventListener('change',changed);

// ---------------------------------------------------------------- cart
function fromParams(fd){
 var item={id:fd.get('id'),quantity:fd.get('quantity')||1,properties:{}};
 fd.forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m)item.properties[m[1]]=v;});
 if(fd.get('selling_plan'))item.selling_plan=fd.get('selling_plan');
 var p={items:[item]};['sections','sections_url'].forEach(function(k){if(fd.get(k))p[k]=fd.get(k);});return p;
}
function isScoped(payload){return (payload.items||[payload]).some(function(i){return ids.indexOf(String(i.id))>=0;});}
function withProps(payload){
 var p=props(),out=Object.assign({},payload);
 out.items=(payload.items||[payload]).map(function(it){if(ids.indexOf(String(it.id))<0)return it;return {id:it.id,quantity:it.quantity||1,selling_plan:it.selling_plan,properties:Object.assign({},it.properties||{},p)};});
 delete out.id;delete out.quantity;delete out.properties;delete out.selling_plan;return out;
}
// the theme's own add-to-cart runs (mini cart opens as on every other product); we only block an incomplete form and inject the properties
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('.buy-button__add button,xo-cart-add,.sticky-addcart__add,[name="add"],[data-add-to-cart]');if(!b)return;
 var f=b.closest('form');if(f&&!target(f))return;
 if(!f){var product=b.closest('xo-product');if(!b.closest('.sticky-addcart')&&(!product||String(product.getAttribute('xo-product-id'))!==root.dataset.product))return;}
 if(!warning()){e.preventDefault();e.stopImmediatePropagation();}
},true);
document.addEventListener('submit',function(e){if(!target(e.target)||!/\/cart\/add/.test(e.target.action))return;if(!warning()){e.preventDefault();e.stopImmediatePropagation();}},true);
window.fetch=async function(u,init){
 var url=typeof u==='string'?u:u&&u.url||'';
 if(!/\/cart\/add(?:[.?/]|$)/.test(url))return nativeFetch(u,init);
 var body=init&&init.body,request=typeof Request!=='undefined'&&u instanceof Request;
 if(body===undefined&&request)body=await u.clone().text();
 var payload=null;
 try{if(typeof body==='string'){if(body.trim().charAt(0)==='{')payload=JSON.parse(body);else{var pars=new URLSearchParams(body);if(pars.has('id'))payload=fromParams(pars);}}else if(body instanceof FormData||body instanceof URLSearchParams){payload=fromParams(body);}}catch(e){}
 if(!payload||!isScoped(payload))return nativeFetch(u,init);
 if(!warning())throw Error('Please complete your personalization.');
 var bundled=withProps(payload),headers=new Headers(init&&init.headers||(request?u.headers:undefined));headers.set('Content-Type','application/json');
 var options=Object.assign({},init,{method:init&&init.method||(request?u.method:'POST'),headers:headers,body:JSON.stringify(bundled)});
 return nativeFetch(request?u.url:u,options);
};

// style (Lounge / Sweatpants) switches the pants mockup
setInterval(function(){var el=document.querySelector('form.sb-form [name="id"]'),id=el&&el.value;if(id!==lastId){var first=lastId===null;lastId=id;if(!first&&latest)run();}},500);
// ---------------------------------------------------------------- boot
motifs().then(drawSwatches).catch(function(){});pants(styleNow());
(function(){function go(){(window.requestIdleCallback||function(f){setTimeout(f,200);})(function(){if(!latest)run();},{timeout:2500});}
 if(document.readyState==='complete')go();else window.addEventListener('load',go,{once:true});})();
if(R.fontReady)R.fontReady.then(function(){if(latest)run();});
relocate();sync();
var mutationTimer;new MutationObserver(function(){clearTimeout(mutationTimer);mutationTimer=setTimeout(function(){relocate();sync();if(latest){setGallery(latest);inset();}},100);}).observe(document.body,{childList:true,subtree:true});
// keep the gallery under the sticky header
var gallery=document.querySelector('.xo-product-info-media-style3'),header=document.querySelector('.header-v18__sticky,xo-animate.xo-header')||document.querySelector('header');
if(gallery&&header){var lastTop=null;gallery.style.transition='top .15s ease';
 var sticky=function(){var t=window.innerWidth>=750?Math.round(Math.max(16,Math.min(220,header.getBoundingClientRect().bottom+16))):null;if(t!==lastTop){lastTop=t;gallery.style.top=t===null?'':t+'px';}};
 window.addEventListener('scroll',sticky,{passive:true});window.addEventListener('resize',sticky);setInterval(sticky,100);sticky();}
})();
